/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import '../../../assets/style/sass/community.scss';
import {
  Box,
  Grid,
  Dialog,
  Divider,
  Typography,
  DialogActions,
  DialogContent,
  Select,
  MenuItem,
  Chip,
  SelectChangeEvent
} from '@mui/material';
import _ from 'lodash';
import {
  rolesArray,
  topicArray,
  industryArray,
  IsAgileExecutive,
  formatNumberWithCommas,
  useRoleOptionLabel,
  sortedCountries as countries
} from '../components/common';
import { API } from '../../../api';
// import { toast } from 'react-toastify';
import ROLES from '../../../utils/roles';
import { useNavigate } from 'react-router';
import UserCard from './community/UserCard';
import { useAuth0 } from '@auth0/auth0-react';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useLoader } from '../components/useLoader';
import { useModule } from '../../../utils/useModule';
import { getUserDetails } from '../../../utils/orgName';
import FilterLoader from '../components/filter/FilterLoader';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { AGILE_ALLOWED_CATEGORY_COMMUNITY } from '../../../utils/constants';
import { useMemberWord } from '../../../utils/memberTypeLabels';
// import UserProfileDetailsPopup from '../components/UserProfileDetailsPopup';
import CommonModalHeader from '../../../components/DialogUi/CommonModalHeader';
import DosenButton from '../../../components/ui/Buttons/DosenButton';
import { FilterCheckField, FilterSearch } from '../components/filter/FilterProperty';
import { fetchCommunityMember } from '../../../redux/slices/communityMembers/communityMembersSlice';
import { communityFilterAction } from '../../../redux/slices/community-filters/communityFilterSlice';
import { camelCaseToCapitalIndustries, capitalToCamelCaseIndustries } from '../../../utils/industriesMapping';
import { MOBILE_SX, useIsMobileApp } from '../../../mobile/mobileApp';

interface FilterVariables {
  applyFilter: boolean;
}

interface IInitialState {
  loading: boolean;
  data: any;
  error: boolean;
  errorText: string;
}

interface CommunityMember {
  bio: Record<string, any>;
  digital_intro: Record<string, any>;
  displayName: string;
  id: {
    category: string;
    coId: string;
    communicationId: string;
    country: string;
    disability: string[];
    dob: string;
    email: string;
    ethnicity: string;
    firstGenStudent: string;
    firstName: string;
    ftue: boolean;
    gender: string;
    headshot: string;
    hobbies: string[];
    isActive: boolean;
    lastName: string;
    name: string;
    phoneNumber: string;
    phonePrefix: string;
    social: {
      facebook: string;
      instagram: string;
      linkedIn: string;
      twitter: string;
      youtube: string;
      // Add any other social properties as needed
    };
    timezone: string;
  };
  userId: string;
  // Add any other properties as needed
}

const Community = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth0();
  const { orgId, location } = getUserDetails();
  const [loading, setLoading] = useState<boolean>(true);
  const [filterVariables, setFilterVariables] = useState<FilterVariables>({
    applyFilter: false
  });
  let roles: any[] = rolesArray();
  // The role options stay 'Mentee' / 'Mentor' / 'Admin' (the filter compares them); they read as the org's words.
  const roleLabel = useRoleOptionLabel();
  const w = useMemberWord();
  const orgDetails = useAppSelector((state) => state.orgDetails.data?.userTypes);
  let customerCategory: any[] = orgDetails || [];
  const { applyFilter } = filterVariables;
  const [openFilter, setOpenFilter] = React.useState(false);
  const [allCommunityMembersList, setAllCommunityMembersList] = useState<any[]>([]);
  const [selectedRole, setSelectedRole] = useState<string[]>([]);
  const [selectedUserType, setSelectedUserType] = useState<string[]>([]);
  const [selectedIndustry, setselectedIndustry] = useState<string[]>([]);
  const [selectedSkillType, setSelectedSkillType] = useState<string[]>([]);
  const [selectedHobbies, setselectedHobbies] = useState<string[]>([]);
  const [selectedBsIndustries, setSelectedBsIndustries] = useState<string[]>([]);
  const [hobbiesList, setHobbiesList] = useState<string[]>([]);
  const [industryList, setIndustryList] = useState<string[]>([]);
  const [bsIndustriesList, setBsIndustriesList] = useState<string[]>([]);
  const [skillTypeList, setSkillTypeList] = useState<string[]>([]);
  const uniqueSkillTypelist = [...new Set(skillTypeList)];
  const uniqueBsIndustrieslist = [...new Set(bsIndustriesList)];
  const [countryList, setCountryList] = useState(countries);
  const [selectedCountries, setSelectedCountries] = useState<string[]>([]);
  const { isMentorship, isHybrid } = useModule();
  const showObjectivesFilter = isMentorship || isHybrid;
  const [selectedObjectives, setSelectedObjectives] = useState<string[]>([]);
  const [objectivesList, setObjectivesList] = useState<{ id: string; objective: string }[]>([]);
  const [objectivesLoading, setObjectivesLoading] = useState(false);
  const selectedGroupId = useAppSelector((state) => state.selectedGroup.data);
  const grpId = selectedGroupId?.id;
  const [searchObjectives, setSearchObjectives] = useState('');
  const handleCountryChange = (country: string) => {
    setSelectedCountries((prevCountry) =>
      prevCountry?.includes(country) ? prevCountry?.filter((c) => c !== country) : [...(prevCountry || []), country]
    );
  };

  const handleSearchCountry = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchCountry(event.target.value);
    const { value } = event.target;
    const filteredCountries = countries.filter((country) => country.label.toLowerCase().includes(value.toLowerCase()));
    setCountryList(filteredCountries);
  };

  // Skill
  const topics = topicArray();
  const [searchTopics, setSearchTopics] = useState<string>('');
  const [searchCounrty, setSearchCountry] = useState<string>('');
  const topicsList = uniqueSkillTypelist.map((tag) => {
    const index = topics.findIndex((each) => each.name.toLowerCase() === tag.toLowerCase());
    if (index !== -1) {
      return { label: topics[index].label, name: topics[index].name };
    }
    return { label: tag, name: tag };
  });

  // basic settings industries
  const industries = industryArray();
  const filteredBsIndustriesList = uniqueBsIndustrieslist.map((tag) => {
    const index = industries.findIndex((each) => each.name.toLowerCase() === tag.toLowerCase());
    if (index !== -1) {
      return { label: industries[index].label, name: industries[index].name };
    }
    return { label: tag, name: tag };
  });

  const filteredTopicsList = topicsList.filter((tags) => tags.name.toLowerCase().includes(searchTopics.toLowerCase()));
  const communityMembers = useAppSelector((state) => state.getCommunityMembers);
  const communityFilters = useAppSelector((state) => state.communityFilters.data);
  const categoryUserType = useAppSelector((state) => state?.orgDetails.data?.orgType) || [];
  const showLoader = useLoader(loading && communityMembers?.loading, 1000);
  // const [searchSkillTerm, setSearchSkillTerm] = useState<string>('');

  const selectSx = {
    mt: 1,
    width: '100%',
    background: '#0F0F0F',
    borderRadius: 1,
    color: '#FDFDFD',
    '.MuiSelect-icon': { color: '#FDFDFD' },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#868686' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#868686' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#868686', borderWidth: '1px' },
    '&:focus': {
      background: '#0F0F0F'
    }
  };

  const chipSx = {
    backgroundColor: '#1C1C1C',
    color: '#FDFDFD',
    border: '1px solid #2A2A2A'
  };

  const menuItemSx = {
    color: '#FDFDFD',
    background: 'var(--Fill-background, #0F0F0F)',
    '&.Mui-selected': {
      backgroundColor: 'var(--Fill-table, #111)',
      color: '#FDFDFD'
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#1E1E1E'
    }
  };

  /** Dropdown: opens below select, fixed max height so it never covers the select, then scroll */
  const filterSelectMenuProps = {
    anchorOrigin: { vertical: 'bottom' as const, horizontal: 'left' as const },
    transformOrigin: { vertical: 'top' as const, horizontal: 'left' as const },
    disableScrollLock: true,
    PaperProps: {
      sx: {
        background: 'var(--Fill-background, #0F0F0F)',
        color: '#FDFDFD',
        maxHeight: 320,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }
    },
    MenuListProps: {
      sx: { padding: 0, overflow: 'auto', flex: 1, minHeight: 0 }
    }
  };

  /** For open member Profile Details popup */
  // const [openUserProfileDetails, setOpenUserProfileDetails] = React.useState(false);
  // const [selectedMember, setSelectedMember] = useState(null);
  // const handleopenUserProfileDetails = (flag: boolean) => setOpenUserProfileDetails(flag);

  /** Active inactive */
  const isActive = true;
  const getLinkStyles = (isActive?: any) => ({
    color: isActive ? '#df6438' : 'primary',
    fontWeight: isActive ? '600' : 'normal',
    borderBottom: isActive ? '3px solid #df6438' : 'none',
    pb: '17px',
    px: 2
  });

  const navigate = useNavigate();
  const isMobileApp = useIsMobileApp();
  const handleSearchSkills = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTopics(event.target.value);
  };

  // const filteredRoleTypes = skillTypeList.filter((roleType) =>
  //   roleType.toLowerCase().includes(searchTopics.toLowerCase())
  // );

  // const uniqueRoleTypes = [...new Set(filteredRoleTypes)];

  const handleRoleChange = (role: string) => {
    // console.log(`${role} clicked`);
    // const handleIndustryChange = (industry: string) => {
    setSelectedRole((prevRole) =>
      prevRole?.includes(role) ? prevRole?.filter((rol) => rol !== role) : [...(prevRole || []), role]
    );
    // };
  };

  // const topics = topicArray();
  const handleTagChange = (type: string) => {
    const topic = topicsList.find((t) => t.label === type) || { name: type.toLowerCase() };
    setSelectedSkillType((prevTypes) =>
      prevTypes.includes(topic.name) ? prevTypes.filter((t) => t !== topic.name) : [...prevTypes, topic.name]
    );
  };

  const handleBsIndustriesChange = (type: string) => {
    const index = industries.findIndex((each) => each.label === type);
    const name = index !== -1 ? industries[index].name : '';
    setSelectedBsIndustries((prevTypes) =>
      prevTypes.includes(name) ? prevTypes.filter((t) => t !== name) : [...prevTypes, name]
    );
  };

  const createMultiSelectHandler =
    (setter: React.Dispatch<React.SetStateAction<string[]>>) => (event: SelectChangeEvent<string[]>) => {
      const { value } = event.target;
      setter(typeof value === 'string' ? value.split(',') : value);
    };

  const handleObjectivesSelect = createMultiSelectHandler(setSelectedObjectives);
  const handleSkillTypeSelect = createMultiSelectHandler(setSelectedSkillType);
  const handleIndustrySelect = createMultiSelectHandler(setselectedIndustry);
  const handleMemberRoleSelect = createMultiSelectHandler(setSelectedUserType);

  useEffect(() => {
    Promise.all([
      fetchTagList('Hobbies and Interests'),
      fetchTagList('industry'),
      fetchSkillsTopic(),
      fetchIndustries()
    ]).then(([tagList1, tagList2, tagList3, tagList4]) => {
      setHobbiesList(tagList1);
      setIndustryList(camelCaseToCapitalIndustries(tagList4));
      setSkillTypeList(tagList3);
      setBsIndustriesList(tagList4);
    });
    dispatch(
      fetchCommunityMember({
        orgId,
        location,
        role: [],
        category: [],
        industry: [],
        hobbies: [],
        roleType: [],
        objectives: []
      })
    );
  }, []);

  const isAgileExec = IsAgileExecutive();

  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    fetchCommunityMembers(
      selectedRole,
      selectedUserType,
      selectedHobbies,
      selectedIndustry,
      selectedSkillType,
      selectedBsIndustries,
      selectedCountries,
      selectedObjectives
    );
    dispatch(
      communityFilterAction.updateCommunityFilter({
        selectedRole,
        selectedUserType,
        selectedIndustry,
        selectedSkillType,
        selectedHobbies,
        selectedBsIndustries,
        selectedCountries,
        selectedObjectives
      })
    );
  }, [applyFilter]);

  useEffect(() => {
    setSelectedRole(communityFilters?.selectedRole || []);
    setSelectedUserType(communityFilters?.selectedUserType || []);
    setselectedIndustry(communityFilters?.selectedIndustry || []);
    setSelectedSkillType(communityFilters?.selectedSkillType || []);
    setselectedHobbies(communityFilters?.selectedHobbies || []);
    setSelectedBsIndustries(communityFilters?.selectedBsIndustries || []);
  }, [communityFilters]);

  useEffect(() => {
    // handleReset();
    setAllCommunityMembersList(
      communityMembers?.data?.filter((each: any) => {
        if ('isPlatformAdmin' in each) {
          return false; // Exclude platform admins
        }

        if (isAgileExec && each.category && !AGILE_ALLOWED_CATEGORY_COMMUNITY.includes(each.category)) {
          return false; // Exclude members not in the allowed Agile categories
        }

        return true; // Include members that pass the conditions
      }) || []
    );
  }, [communityMembers]);

  useEffect(() => {
    const normalizeObjectives = (list: any[]): { id: string; objective: string }[] => {
      const mapped = list.map((obj: any) =>
        typeof obj === 'string'
          ? { id: obj, objective: obj }
          : {
              id: String(obj?.id ?? obj?._id ?? obj?.objective ?? ''),
              objective: String(obj?.objective ?? obj?.content ?? obj?.title ?? obj?.name ?? obj?.id ?? obj?._id ?? '')
            }
      ).filter((o) => o.id && o.objective);
      const byId = new Map<string, { id: string; objective: string }>();
      mapped.forEach((o) => byId.set(o.id, o));
      return Array.from(byId.values());
    };

    const fetchObjectives = async () => {
      if (!orgId) return;
      setObjectivesLoading(true);
      try {
        if (grpId) {
          const response = await API.getLearningObjectives({ grpId, orgId });
          const raw = response?.data?.data;
          const fromPath =
            (Array.isArray(raw) ? raw : null) ??
            raw?.learningObjectives?.objectives ??
            raw?.learningObjectives?.data ??
            (Array.isArray(raw?.learningObjectives) ? raw.learningObjectives : null) ??
            raw?.objectives ??
            [];
          const list = Array.isArray(fromPath) ? fromPath : [];
          const normalized = normalizeObjectives(list);
          if (normalized.length > 0) {
            setObjectivesList(normalized);
            setObjectivesLoading(false);
            return;
          }
        }
        const fallback = await API.UserLearningObjectives({ orgId });
        const fallbackData = fallback?.data?.data ?? fallback?.data;
        const fallbackList = Array.isArray(fallbackData) ? fallbackData : [];
        setObjectivesList(normalizeObjectives(fallbackList));
      } catch (error) {
        console.error('Error fetching learning objectives:', error);
        setObjectivesList([]);
      } finally {
        setObjectivesLoading(false);
      }
    };

    if (openFilter && (grpId || orgId)) {
      fetchObjectives();
    }
  }, [openFilter, grpId, orgId]);

  const handleOnSelectMember = (mem: any) => {
    /** For big page profile */
    navigate('/app/communitymember', {
      state: {
        mem,
        communityMembers,
        allCommunityMembersList,
        filters: {
          selectedRole,
          selectedUserType,
          selectedIndustry,
          selectedSkillType,
          selectedHobbies,
          selectedBsIndustries
        },
        fromCommunityFirstPage: true
      }
    });

    /** For Popup */
    // setSelectedMember(mem)
    // setOpenUserProfileDetails(true);
  };

  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setSearchTopics('');
    setOpenFilter(false);
    setSearchCountry('');
    setCountryList(countries);
  };

  const handleReset = () => {
    setSelectedRole([]);
    setSelectedUserType([]);
    setselectedHobbies([]);
    setselectedIndustry([]);
    setSelectedSkillType([]);
    setSelectedBsIndustries([]);
    setSelectedCountries([]);
    setSelectedObjectives([]);
    dispatch(
      communityFilterAction.updateCommunityFilter({
        selectedRole: [],
        selectedUserType: [],
        selectedIndustry: [],
        selectedSkillType: [],
        selectedHobbies: [],
        selectedBsIndustries: [],
        selectedCountries: [],
        selectedObjectives: []
      })
    );
    dispatch(fetchCommunityMember({ orgId, location }));
    setSearchCountry('');
    setOpenFilter(false);
    setCountryList(countries);
  };

  useEffect(() => {
    // This function will be called when the component unmounts
    return () => {
      handleReset();
    };
  }, []);

  const handleApply = () => {
    setFilterVariables({
      ...filterVariables,
      applyFilter: !applyFilter
    });
    // console.log(selectedBsIndustries, 'selected bs industries');
    dispatch(
      communityFilterAction.updateCommunityFilter({
        selectedRole: selectedRole,
        selectedUserType: selectedUserType,
        selectedIndustry: selectedIndustry,
        selectedSkillType: selectedSkillType,
        selectedHobbies: selectedHobbies,
        selectedBsIndustries: selectedBsIndustries,
        selectedCountries,
        selectedObjectives
      })
    );
    handleCloseFilter();
  };

  // const handleSkillTypeChange = (roleType: string) => {
  //   setSelectedSkillType((prevRoleType) =>
  //     prevRoleType?.includes(roleType)
  //       ? prevRoleType?.filter((role) => role !== roleType)
  //       : [...(prevRoleType || []), roleType]
  //   );
  // };

  // const handleSkillTypeChange = (type: string) => {
  //   const index = topics.findIndex((each) => each.label === type);
  //   // const name = index ? topics[index].name : '';
  //   const name = index !== -1 ? topics[index].name : '';

  //   setSelectedSkillType((prevTypes) =>
  //     prevTypes.includes(name) ? prevTypes.filter((t) => t !== name) : [...prevTypes, name]
  //   );
  // };

  /** Get bio */
  const getBio = (mem: any) => {
    const category = _.get(mem, 'category', '');
    const { major = '', university = '' } = _.get(mem, 'bio.education', {});
    const { role = '', companyName = '' } = _.get(mem, 'bio.workHistory', {});

    return category === 'Student'
      ? `${major}${major && university ? ', ' : ''}${university}`
      : `${role}${role && companyName ? ', ' : ''}${companyName}`;
  };

  const fetchCommunityMembers = async (
    roleSelected: string[],
    category: string[],
    hobbiesAndInterest: string[],
    industry: string[],
    skillType: string[],
    bsIndustries: string[],
    countries: string[],
    objectives: string[]
  ) => {
    setLoading(true);

    const filteredResponse =
      communityMembers?.data &&
      (roleSelected?.length ||
        hobbiesAndInterest?.length ||
        industry?.length ||
        skillType?.length ||
        bsIndustries?.length ||
        countries?.length ||
        category?.length ||
        objectives?.length)
        ? communityMembers?.data.filter((member: any) => {
            // const roleMatch = member?.userType?.some((each: any) => roleSelected?.map(s => s.toLowerCase().includes(each.toLowerCase())))
            const roleMatch =
              category?.length > 0
                ? category.some((selectedRole) => {
                    if (selectedRole === 'Admin') {
                      return (
                        member?.roleType?.includes('OrgAdmin') ||
                        member?.roleType?.includes('PlatformAdmin') ||
                        member?.roleType?.includes('Admin')
                      );
                    } else {
                      return member?.roleType?.some(
                        (role: string) => role.toLowerCase() === selectedRole.toLowerCase()
                      );
                    }
                  })
                : true;

            const hobbiesMatch =
              hobbiesAndInterest?.length > 0
                ? member?.hobbies?.some((hobby: any) =>
                    hobbiesAndInterest?.map((s) => s.toLowerCase()).includes(hobby.toLowerCase())
                  )
                : true;
            // const industryMatch =
            //   industry?.length > 0
            //     ? member?.industries?.some((ind: any) =>
            //         industry?.map((s) => s.toLowerCase()).includes(ind.toLowerCase())
            //       )
            //     : true;
            const convertedIndustry = capitalToCamelCaseIndustries(industry);
            const industryMatch =
              industry?.length > 0
                ? member?.savedIndustries?.some((ind: any) =>
                    convertedIndustry?.map((s) => s.toLowerCase()).includes(ind.toLowerCase())
                  )
                : true;
            const skillsMatched =
              skillType?.length > 0
                ? member?.savedTopics?.some((skill: any) =>
                    skillType?.map((s) => s.toLowerCase()).includes(skill.toLowerCase())
                  )
                : true;
            const bsIndustriesMatched =
              bsIndustries?.length > 0
                ? member?.savedIndustries?.some((bsInd: any) =>
                    bsIndustries?.map((s) => s.toLowerCase()).includes(bsInd.toLowerCase())
                  )
                : true;
            // const categoryMatch = category?.length > 0 ? category?.includes(member?.category || '') : true;

            const countryMatch = countries?.length > 0 ? countries?.includes(member?.company?.location || '') : true;
            const objectivesMatch =
              objectives?.length > 0
                ? Array.isArray(member.learningObjectives)
                  ? member.learningObjectives.some((obj: any) => obj?.id && objectives.includes(obj.id))
                  : false
                : true;

            return (
              roleMatch &&
              hobbiesMatch &&
              industryMatch &&
              skillsMatched &&
              bsIndustriesMatched &&
              countryMatch &&
              // categoryMatch &&
              objectivesMatch
            );
            // return roleMatch
          })
        : communityMembers?.data;

    // if (response?.status === 200 ) {
    //   if (Array.isArray(response?.data.memberResponse)) {
    //     setAllCommunityMembersList(
    //       response?.data?.memberResponse?.filter((each: any) => {
    //         if ('isPlatformAdmin' in each) {
    //           return false; // Exclude platform admins
    //         }

    //         if (isAgileExec && each.category && !AGILE_ALLOWED_CATEGORY_COMMUNITY.includes(each.category)) {
    //           return false; // Exclude members not in the allowed Agile categories
    //         }

    //         return true; // Include members that pass the conditions
    //       }) || []
    //     );

    setAllCommunityMembersList(
      filteredResponse?.filter((each: any) => {
        if ('isPlatformAdmin' in each) {
          return false; // Exclude platform admins
        }

        if (isAgileExec && each.category && !AGILE_ALLOWED_CATEGORY_COMMUNITY.includes(each.category)) {
          return false; // Exclude members not in the allowed Agile categories
        }

        return true; // Include members that pass the conditions
      }) || []
    );

    // } else {
    //   setAllCommunityMembersList([]);
    // }
    setLoading(false);
    // }
    // } catch (error) {
    //   setLoading(false);
    //   toast.error('Failed while loading community list');
    // }}
  };

  const [showCompany, setShowCompany] = useState(false);
  const role = localStorage.getItem('role') || '';
  const isPlatformAdmin = role === ROLES.platAdmin;
  const isOrgAdmin = role === ROLES.orgAdmin;

  useEffect(() => {
    if (communityMembers?.data) {
      const isCompanyExist = communityMembers.data.some((each) =>
        each?.company && ![ROLES.orgAdmin, ROLES.platAdmin].includes(each.roleType) ? true : false
      );
      if (isCompanyExist) {
        setShowCompany(true);
      } else {
        setShowCompany(false);
      }
    }
  }, [communityMembers]);

  /** Fetch tag list */
  const fetchTagList = async (type: string) => {
    try {
      const responseFYE = await API.getTagsListnew(orgId, location, type, '', true);
      if (responseFYE.status === 200) {
        // console.log(responseFYE?.data?.tagListResponse, 'console log');
        return responseFYE?.data?.tagListResponse?.map((each: any) => each.value) || [];
      } else {
        return [];
      }
    } catch {
      return [];
    }
  };

  const fetchIndustries = async () => {
    try {
      const response = await API.getAllIndustriesForUser(location);
      if (response.status === 200) {
        return (
          // response?.data?.industries?.sort()?.map((topic: any) => topic?.charAt(0)?.toUpperCase() + topic?.slice(1)) ||
          // []
          response?.data?.industries?.sort() || []
        );
      } else {
        return [];
      }
    } catch {
      return [];
    }
  };

  const fetchSkillsTopic = async () => {
    try {
      const response = await API.getAllTopicsForUser(location);
      if (response.status === 200) {
        return (
          response?.data?.topics?.sort()?.map((topic: any) => topic?.charAt(0)?.toUpperCase() + topic?.slice(1)) || []
        );
      }
    } catch {
      return [];
    }
  };

  if (communityMembers?.error) {
    return <Box>{communityMembers?.errorText}</Box>;
  }

  return (
    <>
      {/* Phone: the page grows with the people list, so the app's own scroll area scrolls it. */}
      <Box className="bodyBox" sx={{ [MOBILE_SX]: { height: 'auto', overflow: 'visible' } }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            // p: '25px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '80px',
            [MOBILE_SX]: { height: 'auto' }
          }}
        >
          {/* TABLE WRAPPER */}
          <Box
            sx={{
              alignSelf: 'stretch',
              flex: '1 1 0',
              background: 'var(--Fill-Table-table-primary, #1C1C1C)',
              overflow: 'hidden',
              borderRadius: '8px',
              outline: '1px solid var(--Stroke-table-primary, #2A2A2A)',
              outlineOffset: '-1px',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
              [MOBILE_SX]: { flex: 'none' }
            }}
          >
            {/* HEADER */}
            <Box
              sx={{
                width: '100%',
                height: '82px',
                px: '25px',
                py: '20px',
                borderBottom: '1px solid var(--Stroke-table-primary, #2A2A2A)',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                // Phone: one compact bar; the active filters swipe between the count and the filter button.
                [MOBILE_SX]: { height: 'auto', minHeight: 64, px: '12px', py: '12px' }
              }}
            >
              {/* Left counter */}
              <Typography
                sx={{
                  color: '#FDFDFD',
                  fontSize: '16px',
                  fontWeight: 600,
                  fontFamily: 'Inter',
                  [MOBILE_SX]: { flexShrink: 0, whiteSpace: 'nowrap' }
                }}
              >
                {formatNumberWithCommas(allCommunityMembersList?.length)}{' '}
                {allCommunityMembersList?.length === 1 ? 'person' : 'people'}
              </Typography>

              {/* Divider */}
              <Box
                sx={{
                  width: '1px',
                  height: '100%',
                  background: '#2A2A2A',
                  [MOBILE_SX]: { alignSelf: 'stretch', height: 'auto' }
                }}
              />

              {/* Active filters */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  flexWrap: 'wrap',
                  [MOBILE_SX]: {
                    flex: 1,
                    minWidth: 0,
                    flexWrap: 'nowrap',
                    gap: '8px',
                    overflowX: 'auto',
                    scrollbarWidth: 'none',
                    '&::-webkit-scrollbar': { display: 'none' },
                    '& > *': { flexShrink: 0 },
                    '& p': { whiteSpace: 'nowrap' }
                  }
                }}
              >
                <Typography sx={{ color: '#FDFDFD', fontSize: '14px', fontWeight: 600 }}>Filters:</Typography>

                {/* DYNAMIC FILTER TAGS */}
                {[
                  ...selectedObjectives.map((o) => ({ label: objectivesList.find((ob) => ob.id === o)?.objective })),
                  ...selectedRole.map((r) => ({ label: roleLabel(r) })),
                  ...selectedUserType.map((u) => ({ label: roleLabel(u) })),
                  ...selectedIndustry.map((i) => ({ label: i })),
                  ...selectedSkillType.map((s) => ({ label: s })),
                  ...selectedCountries.map((c) => ({ label: c }))
                ]
                  .filter((f) => f && f.label)
                  .map((filter, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        px: '12px',
                        py: '8px',
                        borderRadius: '20px',
                        outline: '1px solid #444',
                        outlineOffset: '-1px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <Typography
                        sx={{
                          color: '#FDFDFD',
                          fontSize: '12px',
                          fontWeight: 400,
                          lineHeight: '14px'
                        }}
                      >
                        {filter.label}
                      </Typography>
                    </Box>
                  ))}
              </Box>

              {/* OPEN FILTERS BUTTON */}
              <DosenButton
                tone="cta"
                sizeVariant="sm"
                onClick={handleClickOpenFilter}
                sx={{
                  ml: 'auto',
                  minWidth: 40,
                  width: 40,
                  height: 40,
                  p: 0,
                  borderRadius: '50%',
                  [MOBILE_SX]: { flexShrink: 0 }
                }}
              >
                <FilterListIcon sx={{ color: '#FDFDFD', fontSize: 24 }} />
              </DosenButton>
            </Box>

            {/* MEMBER GRID - 5 cards per row, equal width */}
            <Box
              sx={{
                flex: '1 1 0',
                alignSelf: 'stretch',
                p: '25px',
                background: 'var(--Fill-Table-table-highlight, #151515)',
                display: 'grid',
                gridTemplateColumns: 'repeat(5, 1fr)',
                gap: '24px',
                alignContent: 'flex-start',
                overflowY: 'auto',
                minHeight: 0,
                // Phone: two readable cards per row instead of five slivers.
                [MOBILE_SX]: {
                  flex: 'none',
                  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                  gap: '12px',
                  p: '12px',
                  overflowY: 'visible'
                }
              }}
            >
              {allCommunityMembersList?.map((mem) => (
                <UserCard
                  key={mem.id}
                  mem={mem}
                  displayName={mem.displayName}
                  imageUrl={mem?.headshot}
                  category={mem.category}
                  bio={getBio(mem)}
                  cardWidth="100%"
                  cardHeight={isMobileApp ? 'auto' : '250px'}
                  handleOnSelectMember={handleOnSelectMember}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Dialog */}
      <Dialog
        open={openFilter}
        fullWidth
        fullScreen={isMobileApp}
        PaperProps={{
          sx: {
            background: '#0F0F0F',
            color: 'var(--Text-text-primary, #FDFDFD)',
            border: '1px solid #444444',
            // Phone: a full-screen sheet, Reset and Apply pinned at the bottom.
            '&.MuiDialog-paperFullScreen': { border: 'none' }
          }
        }}
      >
        {/* Dialog Header */}
        <Box sx={{ background: '#0F0F0F' }}>
          <CommonModalHeader title="Filter" handleCloseModal={handleCloseFilter} />
        </Box>
        <DialogContent sx={{ background: '#0F0F0F' }}>
          {showLoader ? (
            <FilterLoader />
          ) : (
            <>
              {/* Program Objectives - always show in filter modal */}
              <Box sx={{ mb: 2 }}>
                <Typography variant="h5">Program Objectives</Typography>
                <Typography fontSize="10px" fontStyle="italic" color="var(--Text-text-secondary, #B6B6B6)">
                  These filters apply to both {w('mentor', { lower: true, possessive: true })} areas of expertise and{' '}
                  {w('mentee', { lower: true, possessive: true })} learning objectives
                </Typography>
                {objectivesLoading ? (
                  <Typography sx={{ color: 'var(--Text-text-tertiary, #868686)', fontSize: 14, mt: 1 }}>
                    Loading objectives…
                  </Typography>
                ) : (
                  <Select
                    multiple
                    value={selectedObjectives}
                    onChange={handleObjectivesSelect}
                    displayEmpty
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {(selected as string[]).length === 0 ? (
                          <Typography component="span" sx={{ color: 'var(--Text-text-tertiary, #868686)', fontSize: 14 }}>
                            Select objectives
                          </Typography>
                        ) : (
                          (selected as string[]).map((value) => (
                            <Chip
                              key={value}
                              label={objectivesList.find((obj) => obj.id === value)?.objective || value}
                              size="small"
                              sx={chipSx}
                            />
                          ))
                        )}
                      </Box>
                    )}
                    sx={selectSx}
                    MenuProps={filterSelectMenuProps}
                  >
                    {objectivesList?.length > 0 ? (
                      objectivesList
                        .filter((obj) =>
                          searchObjectives ? obj.objective.toLowerCase().includes(searchObjectives.toLowerCase()) : true
                        )
                        .map((obj) => (
                          <MenuItem key={obj.id} value={obj.id} sx={menuItemSx}>
                            {obj.objective}
                          </MenuItem>
                        ))
                    ) : (
                      <MenuItem disabled sx={menuItemSx}>
                        No objectives available
                      </MenuItem>
                    )}
                  </Select>
                )}
              </Box>
              {/* Skills */}
              {skillTypeList?.length > 0 && (
                <>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="h5">Topics</Typography>
                    {/* <Box pb={1}>
                      <FilterSearch
                        userTypeDate={{ placeholderText: 'Search Skills' }}
                        value={searchTopics}
                        onChange={handleSearchSkills}
                      />
                    </Box> */}
                    <Select
                      multiple
                      value={selectedSkillType}
                      onChange={handleSkillTypeSelect}
                      displayEmpty
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {(selected as string[]).map((value) => (
                            <Chip
                              key={value}
                              label={topicsList.find((topic) => topic.name === value)?.label || value}
                              size="small"
                              sx={chipSx}
                            />
                          ))}
                        </Box>
                      )}
                      sx={selectSx}
                      MenuProps={filterSelectMenuProps}
                    >
                      {filteredTopicsList.length > 0 ? (
                        filteredTopicsList
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((tags) => (
                            <MenuItem key={tags.name} value={tags.name} sx={menuItemSx}>
                              {tags.label}
                            </MenuItem>
                          ))
                      ) : (
                        <MenuItem disabled sx={menuItemSx}>
                          Nothing to see here
                        </MenuItem>
                      )}
                    </Select>
                  </Box>
                </>
              )}
              {/* Industry */}
              {industryList?.length > 0 && (
                <>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="h5">Industries</Typography>
                    <Select
                      multiple
                      value={selectedIndustry}
                      onChange={handleIndustrySelect}
                      displayEmpty
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {(selected as string[]).map((value) => (
                            <Chip key={value} label={value} size="small" sx={chipSx} />
                          ))}
                        </Box>
                      )}
                      sx={selectSx}
                      MenuProps={filterSelectMenuProps}
                    >
                      {industryList
                        ?.slice()
                        ?.sort()
                        ?.map((industry) => (
                          <MenuItem key={industry} value={industry} sx={menuItemSx}>
                            {industry}
                          </MenuItem>
                        ))}
                    </Select>
                  </Box>
                </>
              )}
              <Box sx={{ mb: 2 }}>
                <Typography variant="h5">Role</Typography>
                <Select
                  multiple
                  value={selectedUserType}
                  onChange={handleMemberRoleSelect}
                  displayEmpty
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {(selected as string[]).map((value) => (
                        <Chip key={value} label={roleLabel(value)} size="small" sx={chipSx} />
                      ))}
                    </Box>
                  )}
                  sx={selectSx}
                  MenuProps={filterSelectMenuProps}
                >
                  {roles.map((role, index) => (
                    <MenuItem key={index} value={role} sx={menuItemSx}>
                      {roleLabel(role)}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              {(showCompany || isPlatformAdmin || isOrgAdmin) && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h5">Company Location</Typography>
                  <Box pb={1}>
                    <FilterSearch
                      userTypeDate={{ placeholderText: 'Search Company Location' }}
                      value={searchCounrty}
                      onChange={handleSearchCountry}
                    />
                  </Box>
                  <Box>
                    {countryList.map((tags, index) => (
                      <FilterCheckField
                        key={index}
                        label={tags.label}
                        onChange={handleCountryChange}
                        checked={selectedCountries.includes(tags.label)}
                      />
                    ))}
                  </Box>
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            flexDirection: 'row',
            gap: 1,
            px: 2,
            pb: 2,
            background: '#0F0F0F',
            [MOBILE_SX]: { pt: 1.5, borderTop: '1px solid #2A2A2A' }
          }}
        >
          <DosenButton tone="basic" onClick={handleReset} sizeVariant="md" sx={{ fontWeight: 500, flex: 1 }}>
            Reset
          </DosenButton>
          <DosenButton tone="cta" onClick={handleApply} sizeVariant="md" sx={{ fontWeight: 500, flex: 1 }}>
            Apply Filter
          </DosenButton>
        </DialogActions>
      </Dialog>

      {/* member profile details  */}
      {/* <UserProfileDetailsPopup
        loading={false} // loader
        openUserProfileDetails={openUserProfileDetails}
        handleopenUserProfileDetails={handleopenUserProfileDetails}
        userData={selectedMember}
      /> */}
    </>
  );
};

export default Community;
